const TermsOfService = () => import('@/views/website/terms-of-service');

export default [
  {
    path: 'terms-of-service',
    name: 'website.terms-of-service',
    component: TermsOfService,
  },
];
